import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Label } from '../labels/labels';
import { PayrollUnitName } from './payroll-enums';

export enum PayrollCategoryDrawerFormFieldEnum {
  PayrollCategory = 'payrollCategory',
  Name = 'name',
  ProviderEditingKey = 'providerEditingKey',
  ExternalCategoryId = 'externalCategoryId',
  Unit = 'unit',
  DefaultCostCenter = 'defaultCostCenter',
  CalculatorType = 'calculatorType',
  CalculationMethod = 'calculationMethod',
  ActivityCategoryCalculationMethod = 'activityCategoryCalculationMethod',
  Labels = 'labels',
  Value = 'value',
  ActivityCategoryIds = 'activityCategoryIds',
  CalculationPercentages = 'calculationPercentages',
  CalculationAmounts = 'calculationAmounts',
  TransferDistance = 'transferDistance',
}

export interface PayrollCategoryDrawerFormValue {
  [PayrollCategoryDrawerFormFieldEnum.PayrollCategory]: string | null;
  [PayrollCategoryDrawerFormFieldEnum.Name]: string | null;
  [PayrollCategoryDrawerFormFieldEnum.ProviderEditingKey]: number | null;
  [PayrollCategoryDrawerFormFieldEnum.ExternalCategoryId]: number[] | null;
  [PayrollCategoryDrawerFormFieldEnum.Unit]: PayrollUnitName | null;
  [PayrollCategoryDrawerFormFieldEnum.DefaultCostCenter]: number | null;
  [PayrollCategoryDrawerFormFieldEnum.CalculatorType]?: CalculatorType | null;
  [PayrollCategoryDrawerFormFieldEnum.Labels]?: Label[] | null;
  [PayrollCategoryDrawerFormFieldEnum.CalculationMethod]?: CalculationMethod | null;
  [PayrollCategoryDrawerFormFieldEnum.ActivityCategoryCalculationMethod]?: ActivityCategoryCalculationMethod | null;
  [PayrollCategoryDrawerFormFieldEnum.Value]?: number | null;
  [PayrollCategoryDrawerFormFieldEnum.ActivityCategoryIds]?: string[] | null;
  [PayrollCategoryDrawerFormFieldEnum.CalculationPercentages]?:
    | CalculationPercentage[]
    | null;
  [PayrollCategoryDrawerFormFieldEnum.CalculationAmounts]?:
    | CalculationAmount[]
    | null;
  [PayrollCategoryDrawerFormFieldEnum.TransferDistance]?:
    | TransferDistance[]
    | null;
}

export type PayrollCategoryFormControls = {
  [Property in keyof Omit<
    PayrollCategoryDrawerFormValue,
    | PayrollCategoryDrawerFormFieldEnum.CalculationPercentages
    | PayrollCategoryDrawerFormFieldEnum.CalculationAmounts
    | PayrollCategoryDrawerFormFieldEnum.TransferDistance
  >]: FormControl<PayrollCategoryDrawerFormValue[Property]>;
} & {
  [PayrollCategoryDrawerFormFieldEnum.CalculationPercentages]?: FormArray<
    FormGroup<CalculationPercentageForm>
  >;
} & {
  [PayrollCategoryDrawerFormFieldEnum.CalculationAmounts]?: FormArray<
    FormGroup<CalculationAmountForm>
  >;
} & {
  [PayrollCategoryDrawerFormFieldEnum.TransferDistance]?: FormArray<
    FormGroup<TransferDistanceForm>
  >;
};

export enum PayrollCategoryType {
  AddNewCategory = 'addNewCategory',
  AddNewCustomRule = 'addNewCustomRule',
}

export enum CalculatorType {
  Label = 'label',
  ActivityCategory = 'activity_category',
  TransferDistance = 'transfer_distance',
}

export enum CalculationMethod {
  Fixed = 'fixed',
  Multiplier = 'multiplier',
}

export enum ActivityCategoryCalculationMethod {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

export interface CalculationPercentage {
  from: number;
  percentage: number;
}

export interface CalculationAmount {
  from: number;
  amount: number;
}

export interface TransferDistance {
  from: number;
  ratePerKm: number;
}

export enum CalculationPercentageFormFieldEnum {
  From = 'from',
  Percentage = 'percentage',
}

export enum CalculationAmountFormFieldEnum {
  From = 'from',
  Amount = 'amount',
}

export enum TransferDistanceFormFieldEnum {
  From = 'from',
  RatePerKM = 'ratePerKm',
}

export interface CalculationPercentageForm {
  [CalculationPercentageFormFieldEnum.From]: FormControl<number>;
  [CalculationPercentageFormFieldEnum.Percentage]: FormControl<number>;
}

export interface CalculationAmountForm {
  [CalculationAmountFormFieldEnum.From]: FormControl<number>;
  [CalculationAmountFormFieldEnum.Amount]: FormControl<number>;
}

export interface TransferDistanceForm {
  [TransferDistanceFormFieldEnum.From]: FormControl<number>;
  [TransferDistanceFormFieldEnum.RatePerKM]: FormControl<number>;
}
